 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AudienceAnalysesList~GlobalSetting~Mention~MonitorComparison~MonitorEdit~MonitorList~PostDetail~Sent~26f54328":"AudienceAnalysesList~GlobalSetting~Mention~MonitorComparison~MonitorEdit~MonitorList~PostDetail~Sent~26f54328","AudienceAnalysesList~GlobalSetting~MonitorComparison~MonitorEdit~MonitorList":"AudienceAnalysesList~GlobalSetting~MonitorComparison~MonitorEdit~MonitorList","AudienceAnalysesList":"AudienceAnalysesList","GlobalSetting":"GlobalSetting","MonitorComparison~MonitorEdit~Sentiment":"MonitorComparison~MonitorEdit~Sentiment","Mention~MonitorComparison~Sentiment":"Mention~MonitorComparison~Sentiment","MonitorComparison":"MonitorComparison","MonitorEdit":"MonitorEdit","MonitorList":"MonitorList","Mention":"Mention","PostDetail~Sentiment":"PostDetail~Sentiment","Sentiment":"Sentiment","PostDetail":"PostDetail","AudienceAnalysis":"AudienceAnalysis","Authorize":"Authorize","ContactUs~CookiePolicy~InvestorPage~LandingPage~PrivacyPolicy~TermsOfService":"ContactUs~CookiePolicy~InvestorPage~LandingPage~PrivacyPolicy~TermsOfService","ContactUs":"ContactUs","CookiePolicy":"CookiePolicy","InvestorPage":"InvestorPage","LandingPage":"LandingPage","PrivacyPolicy":"PrivacyPolicy","TermsOfService":"TermsOfService","Platform":"Platform","AudienceNotAvailable":"AudienceNotAvailable"}[chunkId]||chunkId) + "." + {"AudienceAnalysesList~GlobalSetting~Mention~MonitorComparison~MonitorEdit~MonitorList~PostDetail~Sent~26f54328":"880b85ec","AudienceAnalysesList~GlobalSetting~MonitorComparison~MonitorEdit~MonitorList":"7ddb468c","AudienceAnalysesList":"c6303da9","GlobalSetting":"f570da21","MonitorComparison~MonitorEdit~Sentiment":"04945439","Mention~MonitorComparison~Sentiment":"443be83f","MonitorComparison":"bcc7538c","MonitorEdit":"2460ecf6","MonitorList":"f0e78195","Mention":"1d6d9f8b","PostDetail~Sentiment":"9e99428a","Sentiment":"b169b3c5","PostDetail":"ec295ccf","AudienceAnalysis":"04a3171e","Authorize":"06ede7a0","ContactUs~CookiePolicy~InvestorPage~LandingPage~PrivacyPolicy~TermsOfService":"09441439","ContactUs":"df6abd97","CookiePolicy":"a6f993c4","InvestorPage":"4fff625e","LandingPage":"2a3d5b50","PrivacyPolicy":"24b1adbc","TermsOfService":"1230fdd6","Platform":"3eceb550","chunk-2d0a50ef":"a7b51f89","chunk-2d0e5e97":"87153210","AudienceNotAvailable":"257993f9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AudienceAnalysesList~GlobalSetting~Mention~MonitorComparison~MonitorEdit~MonitorList~PostDetail~Sent~26f54328":1,"AudienceAnalysesList~GlobalSetting~MonitorComparison~MonitorEdit~MonitorList":1,"AudienceAnalysesList":1,"GlobalSetting":1,"MonitorComparison~MonitorEdit~Sentiment":1,"Mention~MonitorComparison~Sentiment":1,"MonitorComparison":1,"MonitorEdit":1,"MonitorList":1,"Mention":1,"PostDetail~Sentiment":1,"Sentiment":1,"PostDetail":1,"AudienceAnalysis":1,"Authorize":1,"ContactUs~CookiePolicy~InvestorPage~LandingPage~PrivacyPolicy~TermsOfService":1,"ContactUs":1,"CookiePolicy":1,"InvestorPage":1,"LandingPage":1,"PrivacyPolicy":1,"TermsOfService":1,"Platform":1,"AudienceNotAvailable":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AudienceAnalysesList~GlobalSetting~Mention~MonitorComparison~MonitorEdit~MonitorList~PostDetail~Sent~26f54328":"AudienceAnalysesList~GlobalSetting~Mention~MonitorComparison~MonitorEdit~MonitorList~PostDetail~Sent~26f54328","AudienceAnalysesList~GlobalSetting~MonitorComparison~MonitorEdit~MonitorList":"AudienceAnalysesList~GlobalSetting~MonitorComparison~MonitorEdit~MonitorList","AudienceAnalysesList":"AudienceAnalysesList","GlobalSetting":"GlobalSetting","MonitorComparison~MonitorEdit~Sentiment":"MonitorComparison~MonitorEdit~Sentiment","Mention~MonitorComparison~Sentiment":"Mention~MonitorComparison~Sentiment","MonitorComparison":"MonitorComparison","MonitorEdit":"MonitorEdit","MonitorList":"MonitorList","Mention":"Mention","PostDetail~Sentiment":"PostDetail~Sentiment","Sentiment":"Sentiment","PostDetail":"PostDetail","AudienceAnalysis":"AudienceAnalysis","Authorize":"Authorize","ContactUs~CookiePolicy~InvestorPage~LandingPage~PrivacyPolicy~TermsOfService":"ContactUs~CookiePolicy~InvestorPage~LandingPage~PrivacyPolicy~TermsOfService","ContactUs":"ContactUs","CookiePolicy":"CookiePolicy","InvestorPage":"InvestorPage","LandingPage":"LandingPage","PrivacyPolicy":"PrivacyPolicy","TermsOfService":"TermsOfService","Platform":"Platform","AudienceNotAvailable":"AudienceNotAvailable"}[chunkId]||chunkId) + "." + {"AudienceAnalysesList~GlobalSetting~Mention~MonitorComparison~MonitorEdit~MonitorList~PostDetail~Sent~26f54328":"bb5bf6a2","AudienceAnalysesList~GlobalSetting~MonitorComparison~MonitorEdit~MonitorList":"a2f5448e","AudienceAnalysesList":"7a16380f","GlobalSetting":"cc62b987","MonitorComparison~MonitorEdit~Sentiment":"18819aaf","Mention~MonitorComparison~Sentiment":"c795318b","MonitorComparison":"76d2c898","MonitorEdit":"258336ea","MonitorList":"8ee96b6c","Mention":"adb29711","PostDetail~Sentiment":"5421f506","Sentiment":"8d54529f","PostDetail":"cea2548f","AudienceAnalysis":"f1a771ba","Authorize":"56e24533","ContactUs~CookiePolicy~InvestorPage~LandingPage~PrivacyPolicy~TermsOfService":"da3ce868","ContactUs":"8e4e072a","CookiePolicy":"3ca74ede","InvestorPage":"fbd654c0","LandingPage":"b4ea3d2d","PrivacyPolicy":"80ba0c8b","TermsOfService":"61e2c8ee","Platform":"f3ebb363","chunk-2d0a50ef":"31d6cfe0","chunk-2d0e5e97":"31d6cfe0","AudienceNotAvailable":"2716fbee"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
